import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component TaskListCompleteIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <TaskListCompleteIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <TaskListCompleteIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TaskListCompleteIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="TaskListCompleteIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 18a1 1 0 110 2H5a1 1 0 110-2h6zm0-4a1 1 0 110 2H5a1 1 0 110-2h6zm8-4a1 1 0 110 2H5a1 1 0 110-2h14zm0-6a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h14zm3.192 11.293a1 1 0 010 1.414l-3.657 3.657a1 1 0 01-1.414 0l-1.828-1.828a1 1 0 011.414-1.415l1.12 1.121 2.951-2.95a1 1 0 011.414 0z"
      />
    </svg>
  )
);
TaskListCompleteIcon.displayName = "TaskListCompleteIcon";
export default TaskListCompleteIcon;
